export const translationLivechat_da_edit = {
  livechatEditMessage: "Rediger",
  livechatEditMessageLabel: "Rediger dit svar",
  livechatEditMessageSave: "Gem",
  livechatEditMessageSaving: "Gemmer...",
  livechatEditMessageCancel: "Annuller",
  livechatEditMessageFailed: "Svaret kunne ikke redigeres. Prøv igen.",
  livechatEditMessageNoLongerEditable:
    "Svaret kan ikke længere redigeres. Annuller for at beholde det sendte svar.",
  livechatMessageEdited: "redigeret",
};
